import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';
import { pxToRem } from 'Styles/utils/utils';

export const PaymentContainer = styled(FlexContainer)`
  padding: ${pxToRem(10)};
  margin-left: ${pxToRem(6)};
  margin-right: ${pxToRem(7)};
`;
